import React from "react";
import Header from "../common/Header";

import AllConatacts from "./AllConatacts";
import ContactTabs from "./ContactTabs";

const MyContact = () => {
  return (
    <>
      <div className="bg-light_purple7 rounded-2xl overflow-x-hidden  h-[calc(100vh-32px)]">
        <div className="px-2 xs:px-5">
          <div className=" overflow-hidden">
            <Header text="My Contact" />
          </div>
          <div className="flex flex-col xl:flex-row pt-1">
            <div className="w-full xl:w-[66%]  2xl:w-[60%]">
              <AllConatacts />
            </div>
            <div className="w-full xl:w-[38%] 2xl:w-[40%] pt-5 xl:pt-0 pb-5 xl:pl-4">
              <ContactTabs />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyContact;
